import {
	Content,
	GridItem,
	Progress,
	ProgressMeasureLocation,
	ProgressSize,
	Split,
	SplitItem,
} from "@patternfly/react-core";
import type React from "react";

const ProductScore = ({
	scoreStatus,
	graphValues,
}: {
	scoreStatus: string;
	graphValues: { value: number; color: string; minWidth?: string }[];
}) => (
	<>
		<GridItem>
			<Split hasGutter={false}>
				{graphValues?.map((graph, index) => (
					<SplitItem key={`graph-${index}`} isFilled={true}>
						<Progress
							aria-label={`progress bar ${index}`}
							className="header-product-score__graph"
							style={
								{
									"--pf-v6-c-progress__indicator--BackgroundColor": graph?.color,
									"--pf-v6-c-progress__bar--BackgroundColor": `${graph?.color}20`,
								} as React.CSSProperties
							}
							value={graph?.value || 0}
							size={ProgressSize.sm}
							measureLocation={ProgressMeasureLocation.none}
						/>
					</SplitItem>
				))}
			</Split>
		</GridItem>
		<Content className="products__card__footer__product-status">
			<Content component="p">
				Product Score: <b>{scoreStatus}</b>
			</Content>
		</Content>
	</>
);

export default ProductScore;
